import { CommonApiService } from 'common/services/config';
import { ErrorCodes } from 'common/typings/error-codes';
import LoginService from 'common/services/login';

import { config as appConfig } from 'expertApplication/config/config';
import { AxiosError, AxiosResponse } from 'axios';

class ExpertApiService extends CommonApiService {
	public type = 'expert';

	constructor() {
		super();

		this.request.interceptors.response.use(
			(response: AxiosResponse) => {
				if (response?.data?.statusCode === 101) {
					// for below urls not trigger logout actions
					if (
						LoginService.isAuthenticated() &&
						window.location.pathname !== appConfig.paths.home &&
						window.location.pathname !== appConfig.paths.login
					) {
						LoginService.logOut();
						window.location.href = `${appConfig.paths.login}?unauthorized=true`;
						return Promise.reject(new Error('unauthorized'));
					}
				}
				return response;
			},
			(error: AxiosError) => {
				if (error && error.response) {
					const { status } = error.response;
					if (
						status === ErrorCodes.UNAUTHORIZED ||
						status === ErrorCodes.ACCESS_DENIED ||
						status === ErrorCodes.NOT_FOUND
					) {
						// for example logout action here
					}
				}
				return Promise.reject(error);
			},
		);
	}
}

export { ExpertApiService };
export default new ExpertApiService();
